module.exports = __webpack_public_path__ + "img/coinbase-w.accd31a2.svg";